import Navbar from "../../components/general/Navbar";
import BuyerCheckoutSuccess from "../../components/buyers/BuyerCheckoutSuccess";
import Footer from "../../components/general/Footer";

export default function BuyerCheckoutSuccessPage() {
  return (
    <>
      <Navbar />
      <BuyerCheckoutSuccess />
      <Footer />
    </>
  )
}

